import type { i18n, TFunction } from 'i18next';
import * as Yup from 'yup';
import { SecondStepFormValues } from '../billing-order-new-edit-secondstep-form';

interface createBillingOrderSecondStepSchemaProps {
  t: TFunction<'translation', undefined>;
  i18n: i18n;
  formatter: Intl.NumberFormat;
  itemsMustBeBilled: {
    itemId: string;
    total: number;
  }[];
  discountAmount: number;
}
export const createBillingOrderSecondStepSchema = ({
  t,
  i18n,
  formatter,
  itemsMustBeBilled,
  discountAmount,
}: createBillingOrderSecondStepSchemaProps) => {
  return Yup.object().shape({
    legalEntities: Yup.array()
      .min(1, t('At least one legal entity must be selected'))
      .required(t('Legal entities are required')),
    unitMeasureDistribution: Yup.object().required(t('Unit measure distribution is required')),
    enableDiscounts: Yup.boolean().required(),
    formValues: Yup.array()
      .default([])
      .test(
        'distribution-validation',
        t('Total distributed must equal total to be billed'),
        function (formValues: SecondStepFormValues[]) {
          if (!formValues || formValues.length === 0) return true;
          let totalDistributed = 0;
          formValues.forEach((fv) => {
            fv.items.forEach((item) => {
              totalDistributed += item.amount;
            });
          });

          const totalToBeBilled = itemsMustBeBilled.reduce((sum, item) => sum + item.total, 0);

          if (Math.abs(totalDistributed - totalToBeBilled) > 0.01) {
            return this.createError({
              message: `${t('Total distributed')} ($${formatter.format(
                totalDistributed
              )}) ${t('must equal total to be billed')} ($${formatter.format(totalToBeBilled)})`,
            });
          }

          return true;
        }
      ),
    totalMustBeBilled: Yup.array().optional().default([]),
    discounts: Yup.array().optional().default([]),
  });
};
